const ContactPage = () => (
  <section className="contact-page">
    <header>
      <h2>सम्पर्क सूत्र</h2>
      <span className="caption">Get in Touch</span>
    </header>
    <div className="contact-grid">
      <div>
        <h3>कार्यालय</h3>
        <span className="caption">Office</span>
        <p>आर्य समाज मंदिर, गौशाला रोड, अबोहर</p>
        <span className="caption">
          Arya Samaj Mandir, Gaushala Road, Abohar
        </span>
      </div>
      <div>
        <h3>फोन</h3>
        <span className="caption">Phone</span>
        <p>+91 79861 91357</p>
        <span className="caption">Call between 9AM - 6PM IST</span>
      </div>
    </div>
    <div className="contact-message">
      <p>
        आगामी सेवा शिविर, वैदिक यज्ञ अथवा अन्य गतिविधियों हेतु सहयोग के लिए हमसे
        अवश्य जुड़ें।
      </p>
      <span className="caption">
        Connect with us for upcoming service camps, Vedic yajnas, or
        collaborative initiatives.
      </span>
    </div>
  </section>
);

export default ContactPage;
